import React from 'react'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import { message } from 'antd'
import { autobind } from 'core-decorators'
import LanguageLocaleApi from 'api/LanguageLocaleApi'
import slug from 'constants/slug'
import LanguageLocaleForm from '../language-locale-form'
import Breadcrumb from '../breadcrumb'

@autobind
export default class StationTypeCreate extends React.PureComponent {
  async handleSubmit(data) {
    const res = await LanguageLocaleApi.createLanguageLocale(data)
    if (res.success) {
      message.info('Add success!')
      this.props.history.push(slug.stationType.list)
    }
  }

  render() {
    return (
      <PageContainer title="Create station type" {...this.props.wrapperProps}>
        <Breadcrumb items={['list', 'create']} />
        <LanguageLocaleForm onSubmit={this.handleSubmit} />
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/language-locale/language-locale-create/index.js